module.exports = __webpack_public_path__ + "static/de-0bdd2210811941b58b3ff4ae20a91a31.svg";